import React, { useEffect } from 'react';

import styles from './DashSynod.module.scss';
import QuestionsTable from './QuestionsTable';

const DashSynod = () => {

  useEffect(()=>{
    console.log(window.location.host)
  },[])

  return (
    <div className={styles.container}>
      <div className={styles.tableDiv}>
        <QuestionsTable />
      </div>
    </div>
  )

}

export default DashSynod;